export default () => {
  
  const header = document.querySelector('.header');
  const button = document.querySelector('.hamburger');
  const links = [...document.querySelectorAll('.header-menu__link')];
  let opened = false;

  button.addEventListener('click', () => {
    header.classList.toggle('header--open');

    if(!opened) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    opened = !opened;
  });

  links.forEach(link => {
    link.addEventListener('click', () => {
      header.classList.remove('header--open');
      document.body.style.overflow = '';
    })
  })
}
